require("./page/salepages/index.js");
Vue.component("floating-button-action", require("./page/FloatingButtonAction.vue").default);